module.exports = __webpack_public_path__ + "img/t1-16.f874a200.png";